import {
  Directive,
  Output,
  EventEmitter,
  ElementRef,
  AfterViewInit,
  OnDestroy,
} from '@angular/core';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[deferLoad]',
  standalone: true,
})
export class DeferLoadDirective implements AfterViewInit, OnDestroy {
  @Output() public deferLoad = new EventEmitter<any>();

  public intersectionObserver: IntersectionObserver;

  constructor(private element: ElementRef) {}

  public ngAfterViewInit() {
    if ('IntersectionObserver' in window && 'IntersectionObserverEntry' in window) {
      this.intersectionObserver = new IntersectionObserver((entries) => {
        this.checkForIntersection(entries);
      }, {});
      this.intersectionObserver.observe(this.element.nativeElement as Element);
    } else {
      this.deferLoad.emit();
    }
  }

  public ngOnDestroy() {
    if (this.intersectionObserver) {
      this.intersectionObserver.disconnect();
    }
  }

  private checkForIntersection(entries: IntersectionObserverEntry[]) {
    entries.forEach((entry: IntersectionObserverEntry) => {
      if (this.checkIfIntersection(entry)) {
        this.deferLoad.emit();
        this.intersectionObserver.unobserve(this.element.nativeElement as Element);
        this.intersectionObserver.disconnect();
      }
    });
  }

  private checkIfIntersection(entry: IntersectionObserverEntry) {
    return entry.isIntersecting && entry.target === this.element.nativeElement;
  }
}
